import { useState } from "react";
import { format, startOfToday, addDays } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";

export const DatePicker = ({ value, onChange, testid = "date-picker", allowPast = false, days, windowDays = 14 }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  const disabled = allowPast
    ? undefined
    : [{ before: startOfToday() }, { after: addDays(startOfToday(), windowDays - 1) }, ...(days ? [(d) => !days.includes(d.getDay())] : [])];
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="w-full justify-start h-11 font-normal" data-testid={testid}>
          <CalendarIcon className="mr-2 h-4 w-4 text-muted-foreground" />
          {selected ? format(selected, "EEE, d MMM yyyy") : <span className="text-muted-foreground">Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          disabled={disabled}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
